export default __webpack_public_path__ + "static/media/Home_shop_type-1.5ee7d78e.jpg";